import React from 'react';
import BreadcrumbQA from '../BreadcrumbQA';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataPerformanceTesting } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import { Link } from 'react-router-dom';

const PerformanceTesting = () => {
  return (
    <div className="page-container-performance-testing">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
            <h1 className='heading'>Performance Testing</h1>
          </div>
            <Link to="/performance-testing" className='no-decoration'><BreadcrumbQA text={"Performance Testing"} /></Link>  
            <div className='red-bg-box'></div>
        </div>
        <CardsServices cardDataServices={cardDataPerformanceTesting} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default PerformanceTesting